/**
 * EditorialNumeral — oversized serif numeral used as a section index.
 * Mirrors the `01` `02` `03` numerals in the after-mockups.
 *
 * @example
 *   <EditorialNumeral value={1} size="xl" style="outline" />
 *   <EditorialNumeral value="04" size="lg" style="solid" tone="charcoal" />
 */
import React from "react";

const SIZE = {
  sm: "text-5xl md:text-6xl",
  md: "text-6xl md:text-7xl",
  lg: "text-7xl md:text-8xl",
  xl: "text-[7rem] md:text-[10rem] leading-[0.9]",
};

const TONE = {
  gold:     "var(--gold-base)",
  cream:    "var(--cream-ink)",
  charcoal: "var(--charcoal-ink)",
};

export default function EditorialNumeral({
  value,
  size = "xl",
  style: variant = "outline",
  tone = "gold",
  className = "",
  ...rest
}) {
  const formatted =
    typeof value === "number" && value < 10 ? `0${value}` : String(value ?? "01");
  const color = TONE[tone] || TONE.gold;
  const isOutline = variant === "outline";
  return (
    <span
      aria-hidden="true"
      className={`font-serif italic select-none ${SIZE[size] || SIZE.xl} ${className}`}
      style={
        isOutline
          ? {
              color: "transparent",
              WebkitTextStroke: `1px ${color}`,
            }
          : { color }
      }
      {...rest}
    >
      {formatted}
    </span>
  );
}
